 
/* eslint-disable i18next/no-literal-string */
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box } from "@mui/system";
import env from "env";

export const getCurrentBreakpoint = () => {
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only("xs"));
  const sm = useMediaQuery(theme.breakpoints.only("sm"));
  const md = useMediaQuery(theme.breakpoints.only("md"));
  const lg = useMediaQuery(theme.breakpoints.only("lg"));
  const xl = useMediaQuery(theme.breakpoints.only("xl"));
  const xxl = useMediaQuery(theme.breakpoints.only("xxl"));
  
  if (xs) return "xs";
  if (sm) return "sm";
  if (md) return "md";
  if (lg) return "lg";
  if (xl) return "xl";
  if (xxl) return "xxl";
};

const SFResponsive = () => {
  if (!env.REACT_APP_IS_LOCAL) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#00cc00",
        color: "#fff",
        position: "fixed",
        padding: "1px",
        top: 0,
        right: 0,
        zIndex: 9999,
        fontSize: 8,
        borderBottomLeftRadius: "4px",
      }}
    >
      {window.innerWidth}x{window.innerHeight} ({getCurrentBreakpoint()})
    </Box>
  );
};

export const isResponsiveSize = (size) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.only(size));
};

export const isResponsiveSizeUp = (size) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(size));
};

export const isResponsiveSizeDown = (size) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(size));
};

export default SFResponsive;
